import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import {toast, ToastContainer} from "react-toastify";
import { BottomSheet } from "react-spring-bottom-sheet";
import HeadingSecondary from "../components/ HeadingSecondary";
import Aboutus from "../components/svg/setting/Aboutus";
import Contactus from "../components/svg/setting/Contactus";
import Exit from "../components/svg/setting/Exit";
import Faq from "../components/svg/setting/Faq";
import Healthinstructions from "../components/svg/setting/Healthinstructions";
import LeftArrow from "../components/svg/setting/LeftArrow";
import Profile from "../components/svg/setting/Profile";
import QrCode from "../components/svg/setting/QrCode";
import Support from "../components/svg/setting/Support";




const Setting: React.FC<any> = () => {
  const history = useHistory();

  const notify = () => {
    toast.info("به زودی", {
      position: "top-center",
      autoClose: 1500,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      progress: undefined,
    });
  };

  const logOut = () => {
    try {
      localStorage.removeItem("userLoginInfo");
    } catch (e: any) {
      // console.log(e);
    } finally {
      history.replace("/");
    }
  };

  const [exitBottomSheet, setExitBottomSheet] = useState(false);

  const confirmLogOut = () => {
    setExitBottomSheet(true);
  };

  return (
    <>
      <ToastContainer rtl/>
      <BottomSheet
        open={exitBottomSheet}
        onDismiss={() => setExitBottomSheet(false)}
      >
        <div className="exit-bottom-sheet u-margin-bottom-small-2 u-margin-top-small-3-5">
          <h6 className="u-margin-bottom-small-3">آیا مایل به خروج هستید ؟</h6>
          <div className="exit-bottom-sheet__buttons u-margin-bottom-small-3">
            <button
              className="btn btn--primary u-width-44"
              onClick={() => logOut()}
            >
              بله
            </button>
            <button
              className="btn btn--primary u-width-44 bg-grey"
              onClick={() => setExitBottomSheet(false)}
            >
              خیر
            </button>
          </div>
        </div>
      </BottomSheet>
      <div className="setting">
        <div className="u-margin-top-medium u-margin-bottom-small-2">
          <HeadingSecondary text="تنظیمات" />
        </div>
        <div className="setting__list">
          <Link to="setting/profile">
            <div className="setting__list__row">
              <div className="setting__list__row__right">
                <span className="setting__list__row__right--icon">
                  <Profile />
                </span>
                <span className="setting__list__row__right--title">
                  پروفایل
                </span>
              </div>
              <div className="setting__list__row__left">
                <span>
                  <LeftArrow />
                </span>
              </div>
            </div>
          </Link>

          <div className="line2" />
          <Link to="setting/userInquiry">
            <div className="setting__list__row">
              <div className="setting__list__row__right">
                <span className="setting__list__row__right--icon">
                  <QrCode />
                </span>
                <span className="setting__list__row__right--title">
                  استعلام شناسه QR کد
                </span>
              </div>
              <div className="setting__list__row__left">
                <span>
                  <LeftArrow />
                </span>
              </div>
            </div>
          </Link>
          <div className="line2" />
          <Link to="setting/faq">
            <div className="setting__list__row">
              <div className="setting__list__row__right">
                <span className="setting__list__row__right--icon">
                  <Faq />
                </span>
                <span className="setting__list__row__right--title">
                  سوالات متداول
                </span>
              </div>
              <div className="setting__list__row__left">
                <span>
                  <LeftArrow />
                </span>
              </div>
            </div>
          </Link>
          <div className="line2" />
          {/* <Link to="setting/support"> */}
            <div className="setting__list__row" onClick={notify}>
              <div className="setting__list__row__right">
                <span className="setting__list__row__right--icon">
                  <Support />
                </span>
                <span className="setting__list__row__right--title">
                  پشتیبانی
                </span>
              </div>
              <div className="setting__list__row__left">
                <span>
                  <LeftArrow />
                </span>
              </div>
            </div>
          {/* </Link> */}
          <div className="line2" />
          <Link to="setting/aboutus">
            <div className="setting__list__row">
              <div className="setting__list__row__right">
                <span className="setting__list__row__right--icon">
                  <Aboutus />
                </span>
                <span className="setting__list__row__right--title">
                  درباره ما
                </span>
              </div>
              <div className="setting__list__row__left">
                <span>
                  <LeftArrow />
                </span>
              </div>
            </div>
          </Link>
          <div className="line2" />
          <Link to="setting/contactus">
            <div className="setting__list__row">
              <div className="setting__list__row__right">
                <span className="setting__list__row__right--icon">
                  <Contactus />
                </span>
                <span className="setting__list__row__right--title">
                  تماس با ما
                </span>
              </div>
              <div className="setting__list__row__left">
                <span>
                  <LeftArrow />
                </span>
              </div>
            </div>
          </Link>
          <div className="line2" />
          <Link to="/setting/healthProtocol">
            <div className="setting__list__row">
              <div className="setting__list__row__right">
                <span className="setting__list__row__right--icon">
                  <Healthinstructions />
                </span>
                <span className="setting__list__row__right--title">
                  دستورالعمل های بهداشتی
                </span>
              </div>
              <div className="setting__list__row__left">
                <span>
                  <LeftArrow />
                </span>
              </div>
            </div>
          </Link>
          <div className="line2" />

          {
            <div className="setting__list__row" onClick={confirmLogOut}>
              <div className="setting__list__row__right">
                <span className="setting__list__row__right--icon">
                  <Exit />
                </span>
                <span className="setting__list__row__right--title">خروج</span>
              </div>
              <div className="setting__list__row__left">
                <span>
                  <LeftArrow />
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    </>
  );
};

export default Setting;
